import usePrivateAxios from "@/common/api/usePrivateAxios"
import { useMutation } from "@tanstack/react-query"

interface UseAdvanceEstablishmentProps {
  id?: string
  onSuccess?: () => void
  onError?: () => void
}

export const useAdvanceEstablishmentLead = ({ id, onSuccess, onError }: UseAdvanceEstablishmentProps) => {
  const privateAxios = usePrivateAxios()
  return useMutation({
    mutationKey: ['advanceEstablishment'],
    mutationFn: async () => {
      await privateAxios.put(`/funnel/establishment/leads/${id}/advance`)
    },
    onSuccess,
    onError,
  })
}
